import mushroom from "viettoc-api";
import ValidService from "@/service/ValidService";
import DataForm from "../../../../dataForm/dataFormDaiLy";
import MethodService from "@/service/MethodService";
import SelectAddress from "@/component/SelectAddress";
import DanhSachDaiLyTinh from "./DanhSachDaiLyTinh.vue";
import UploadFileHD from "./UploadFileHD.vue";
import FormDaiLyTinh from "./FormDaiLyTinh.vue";
import VueTagsInput from "@johmun/vue-tags-input";
import Authentication from "@/component/Authentication";
import FileView from "@/component/FileView";
import { Circle4 } from "vue-loading-spinner";
import agentDefaultSrc from "@/img/agent-default.png";
export default {
  components: {
    SelectAddress,
    DanhSachDaiLyTinh,
    UploadFileHD,
    FormDaiLyTinh,
    VueTagsInput,
    Authentication,
    FileView,
    Circle4,
  },
  data() {
    return {
      mData: {
        loading: true,
        reRenderFileViewHopDongFile: 0, // render lại giao diện dialog xem hợp đồng file
        dataForm: MethodService.copyObject(DataForm.dataForm),
        chuKyThanhToan: MethodService.copyObject(DataForm.chuKyThanhToan),
        loaiDongTien: MethodService.copyObject(DataForm.loaiDongTien),
        account: undefined, // tên đăng nhập của đại lý, là email
        validForm: {
          ten: [ValidService.required],
          ten_day_du: [ValidService.required],
          tai_khoan: [ValidService.required, ValidService.checkEmailNew],
          doanh_nghiep: {
            nguoi_dai_dien: {
              ten: [ValidService.required],
              can_cuoc: [ValidService.required, ValidService.checkNumber],
              dien_thoai: [
                ValidService.required,
                ValidService.checkSDTCoDinh_DiDong,
              ],
              email: [ValidService.checkEmailNew],
            },
            ma_so_thue: [ValidService.required],
            dien_thoai: [
              ValidService.required,
              ValidService.checkSDTCoDinh_DiDong,
            ],
            email: [ValidService.checkEmailNew],
            nguoi_lien_he: {
              ten: [ValidService.required],
              can_cuoc: [ValidService.required, ValidService.checkNumber],
              dien_thoai: [
                ValidService.required,
                ValidService.checkSDTCoDinh_DiDong,
              ],
              email: [ValidService.checkEmailNew],
            },
          },
          ca_nhan: {
            ten: [ValidService.required],
            can_cuoc: [ValidService.required, ValidService.checkNumber],
            dien_thoai: [
              ValidService.required,
              ValidService.checkSDTCoDinh_DiDong,
            ],
            email: [ValidService.checkEmailNew],
          },
          cau_hinh: {
            dang_ky_dong_ho: {
              so_ngay_dung_thu: [ValidService.requiredBlur],
            },
          },
          chu_ky_thanh_toan: [ValidService.required],
          loai_dong_tien: [ValidService.required],
          thong_tin_thanh_toan: {
            ngan_hang_id: [],
            so_tai_khoan: [],
            ten_chu_tai_khoan: []
          }
        },
        viewMode: "create",
        isAddAgentSuccess: false, // form tải hợp đồng
        isAddAgentList: false, // form thêm đại lý tỉnh
        isUpdateStatusActiveAgent: false, // trạng thái đã tải hợp đồng lên thành công để cập nhật trạng thái hoạt động đại lý
        idHopDong: "",
        thong_tin_dai_ly: {},
        them_dai_ly_tinh: false, // dialog thêm đại lý tỉnh
        cap_nhat_dai_ly_tinh: false, // dialog cập nhật đại lý tỉnh
        xem_dai_ly_tinh: false, // dialog xem đại lý tỉnh
        thong_tin_dai_ly_tinh: [],
        listPmtNganHangs: [],
        dataCopy: {},
      },
      activeInfo: ["1", "2", "3", "4"],
      arr: [],
      tag: "",
      tags: [],
      flagHavePayment: false,
      reRenderDanhSachDaiLyTinh: 0,
      isCapNhatLaiThongTinDaiLy: false, // hiển thị dialog xác nhận cập nhật lại thông tin đại lý
      isPheDuyetDaiLy: false, // hiển thị dialog phê duyệt đại lý
      isCapNhatTrangThaiDaiLy: false, // hiển thị dialog xác nhận cập nhật trạng thái đại lý tỉnh
      trang_thai_dai_ly_tinh: "", // ngung_hop_tac, hop_tac
      listVoucherTagsSuggest: [],
      dialogHopDong: false, // hiển thị xem file hợp đồng của đại lý
      list_id_hop_dong_file: [], // list id của hợp đồng
      list_id_hop_dong_clone: [],
      avatarUploadSrc: null,
      is_loading_avatar: false,
    };
  },
  methods: {
    async initDataDefault() {
      try {
        const pmtNganHangRes = await mushroom.pmt_ngan_hang.listAsync({
          limit: 1000
        })
        pmtNganHangRes.result.forEach(item => {
          item.ten_ngan_hang_day_du = `${item.ten} - ${item.ten_ngan}`
        })
        this.mData.listPmtNganHangs = pmtNganHangRes.result
      }
      catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    checkValidatePayment() {
      if (this.flagHavePayment) return
      if (
        this.mData.dataForm.thong_tin_thanh_toan.ngan_hang_id ||
        this.mData.dataForm.thong_tin_thanh_toan.so_tai_khoan ||
        this.mData.dataForm.thong_tin_thanh_toan.ten_chu_tai_khoan ||
        this.mData.dataForm.thong_tin_thanh_toan.chi_nhanh
      ) {
        this.setValidatePayment()
        this.$refs['ruleForm'].validateField("thong_tin_thanh_toan.ngan_hang_id")
        this.$refs['ruleForm'].validateField("thong_tin_thanh_toan.so_tai_khoan")
        this.$refs['ruleForm'].validateField("thong_tin_thanh_toan.ten_chu_tai_khoan")
      } else {
        this.mData.validForm.thong_tin_thanh_toan = {
          ngan_hang_id: [],
          so_tai_khoan: [],
          ten_chu_tai_khoan: []
        }
        this.$refs['ruleForm'].clearValidate("thong_tin_thanh_toan.ngan_hang_id")
        this.$refs['ruleForm'].clearValidate("thong_tin_thanh_toan.so_tai_khoan")
        this.$refs['ruleForm'].clearValidate("thong_tin_thanh_toan.ten_chu_tai_khoan")
      }
    },
    setValidatePayment() {
      this.mData.validForm.thong_tin_thanh_toan = {
        ngan_hang_id: [ValidService.required],
        so_tai_khoan: [ValidService.required, ValidService.checkNumber, ValidService.checkMinLength(8)],
        ten_chu_tai_khoan: [ValidService.required]
      }
      console.log('this.mData.validForm', this.mData.validForm);
    },
    validateByField(field) {
      this.$refs['ruleForm'].validateField(field)
      // this.$refs['ruleForm'].validateField("thong_tin_thanh_toan.ngan_hang_id")
      // this.$refs['ruleForm'].validateField("thong_tin_thanh_toan.so_tai_khoan")
      // this.$refs['ruleForm'].validateField("thong_tin_thanh_toan.ten_chu_tai_khoan")
    },
    changeNganHang(nganHangId) {
      this.checkValidatePayment()
      const ttNganHang = this.mData.listPmtNganHangs.find(x => x.id === nganHangId)
      if (!nganHangId || !ttNganHang) {
        this.mData.dataForm.thong_tin_thanh_toan.ten_ngan_hang = undefined
      } else {
        this.mData.dataForm.thong_tin_thanh_toan.ten_ngan_hang = ttNganHang.ten
      }
    },
    async fn_uploadAvatar(event) {
      this.is_loading_avatar = true;
      const fileImage = event.target.files;
      const nameImage = fileImage[0].name;
      let typeImage = nameImage.slice(nameImage.indexOf("."));
      if (typeImage != ".jpg" && typeImage != ".png" && typeImage != ".jpeg") {
        this.is_loading_avatar = false;
        window.toastr.warning("Vui lòng chọn đúng định dạng file ảnh");
        return;
      } else {
        try {
          const resUpload = await mushroom.$file.uploadAsync({
            file: fileImage[0],
            name: fileImage[0].name,
            tags: [
              `src:agt_dai_ly,field:logo_id,owner_id:${this.$router.currentRoute.params.id}`,
            ],
          });
          if (resUpload.result) {
            this.mData.dataForm.logo_id = resUpload.result;
            this.avatarUploadSrc = await mushroom.$file.linkBuilder.thumb
              .id(resUpload.result)
              .clip(120, 120, "center")
              .build();
          }
        } catch (e) {
          MethodService.showError(e.code);
        } finally {
          setTimeout(() => {
            this.is_loading_avatar = false;
          }, 2000);
        }
      }
    },
    fn_resetUploadAvatar(event) {
      event.target.value = "";
    },
    fn_deleteAvatar() {
      this.avatarUploadSrc = null;
      this.mData.dataForm.logo_id = null;
    },
    validateSoNgayDungThu() {
      if (this.mData.dataForm.cau_hinh.dang_ky_dong_ho.dung_thu) {
        this.mData.validForm.cau_hinh.dang_ky_dong_ho.so_ngay_dung_thu = [
          ValidService.requiredBlur,
        ];
      } else {
        this.mData.validForm.cau_hinh.dang_ky_dong_ho.so_ngay_dung_thu = [];
      }
    },
    fn_deleteContact(index) {
      this.list_id_hop_dong_clone.splice(index, 1);
      this.fn_updateHopDongAgent(this.list_id_hop_dong_clone);
    },
    changeLoaiTaiKhoan(e) {},
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    fn_themVanPhongGiaoDich() {
      this.mData.dataForm.doanh_nghiep.van_phong_giao_dich.push({
        quoc_gia_id: "",
        tinh_id: "",
        huyen_id: "",
        xa_id: "",
        dia_chi: "",
      });
      this.arr = [...this.mData.dataForm.doanh_nghiep.van_phong_giao_dich];
    },
    fn_removeVanPhongGiaoDich(index) {
      this.mData.dataForm.doanh_nghiep.van_phong_giao_dich.splice(index, 1);
    },
    fn_renderStatusAgent(status) {
      switch (status) {
        case "cho_duyet":
          return `<div class="status__waiting">Chờ duyệt</div>`;
        case "hoat_dong":
          return `<div class="status__active">Hoạt động</div>`;
        case "ngung_hop_tac":
          return `<div class="status__hold">Ngừng hợp tác</div>`;
        case "huy":
          return `<div class="status__cancel">Hủy</div>`;
        default:
          return "";
      }
    },
    fn_showTagsSuggest() {
      (newTags) => (tags = newTags);
    },
    async fn_getAllVoucherTags() {
      try {
        const response =
          await mushroom.agt_dai_ly.views.get_voucher_tagsAsync();
        if (response.result) {
          response.result.forEach((item) => {
            this.listVoucherTagsSuggest.push({ text: item.voucher_tags });
          });
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    async fn_initForm() {
      try {
        const response = await mushroom.agt_dai_ly.findByIdAsync({
          id: this.$router.currentRoute.params.id,
          fields:
            "id,ten,ten_day_du,ma,loai,dia_chi,dien_thoai,logo_id,doanh_nghiep,ca_nhan,thong_tin_thanh_toan,chu_ky_thanh_toan,loai_dong_tien,trang_thai,hop_dong_file_ids,tai_khoan,nguoi_quan_ly_ids,cau_hinh,voucher_tags,thoi_diem_tao,nguoi_tao_id,thoi_diem_cap_nhat,nguoi_cap_nhat_id",
        });
        if (!response.result.doanh_nghiep) {
          response.result.doanh_nghiep = {
            ...this.mData.dataForm.doanh_nghiep,
          };
        }
        if (!response.result.cau_hinh) {
          response.result.cau_hinh = {};
          response.result.cau_hinh.tao_dai_ly_tinh = undefined;
          response.result.cau_hinh.tao_voucher = undefined;
        }
        if (!response.result.cau_hinh.dang_ky_dong_ho) {
          response.result.cau_hinh.dang_ky_dong_ho = {};
          response.result.cau_hinh.dang_ky_dong_ho.dung_thu = undefined;
          response.result.cau_hinh.dang_ky_dong_ho.so_ngay_dung_thu = undefined;
        }
        const res = await this.changeData(response.result);
        res.hop_dong_file_ids
          ? (this.list_id_hop_dong_file = res.hop_dong_file_ids)
          : (this.list_id_hop_dong_file = []);
        this.list_id_hop_dong_clone = [...this.list_id_hop_dong_file];
        this.tags = [];
        if (res.voucher_tags && res.voucher_tags.length > 0) {
          res.voucher_tags.forEach((item) => {
            this.tags.push({ text: item, tiClasses: ["ti-valid"] });
          });
        }

        this.mData.dataForm = res;
        this.validateSoNgayDungThu();
        this.dataCopy = { ...res };
        this.mData.thong_tin_dai_ly.ten_dai_ly = response.result.ten;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      } finally {
        setTimeout(() => {
          this.checkValidatePayment()
          this.mData.loading = false;
        }, 1000);
      }
    },
    changeData(data) {
      if (data.logo_id)
        this.avatarUploadSrc = mushroom.$file.linkBuilder.thumb
          .id(data.logo_id)
          .clip(120, 120, "center")
          .build();
      if (data.loai === "doanh_nghiep") {
        data.ca_nhan = {};
        if (!data.doanh_nghiep.nguoi_dai_dien) {
          data.doanh_nghiep.nguoi_dai_dien = {};
        }
        if (!data.doanh_nghiep.nguoi_lien_he) {
          data.doanh_nghiep.nguoi_lien_he = {};
        }
        if (data.doanh_nghiep.dien_thoai)
          data.doanh_nghiep.dien_thoai = MethodService.formatPhoneRemove84(
            data.doanh_nghiep.dien_thoai
          );
        if (
          data.doanh_nghiep.nguoi_dai_dien &&
          data.doanh_nghiep.nguoi_dai_dien.dien_thoai
        )
          data.doanh_nghiep.nguoi_dai_dien.dien_thoai =
            MethodService.formatPhoneRemove84(
              data.doanh_nghiep.nguoi_dai_dien.dien_thoai
            );
        if (
          data.doanh_nghiep.nguoi_lien_he &&
          data.doanh_nghiep.nguoi_lien_he.dien_thoai
        )
          data.doanh_nghiep.nguoi_lien_he.dien_thoai =
            MethodService.formatPhoneRemove84(
              data.doanh_nghiep.nguoi_lien_he.dien_thoai
            );
      }

      if (data.loai === "ca_nhan") {
        if (data.ca_nhan.dien_thoai)
          data.ca_nhan.dien_thoai = MethodService.formatPhoneRemove84(
            data.ca_nhan.dien_thoai
          );
      }
      if (!data.thong_tin_thanh_toan){
        data.thong_tin_thanh_toan = {
          ngan_hang_id: undefined,
          so_tai_khoan: undefined,
          ten_chu_tai_khoan: undefined,
          ten_ngan_hang: undefined,
          chi_nhanh: undefined
        }
      } else {
        this.flagHavePayment = true
        this.setValidatePayment()
      }
      return data;
    },
    inputEmailValue(data, valueEmail) {
      if (!data || data === "") {
        if (valueEmail === "emailNguoiDaiDien")
          this.mData.dataForm.doanh_nghiep.nguoi_dai_dien.email = null;
        if (valueEmail === "emailNguoiLienHe")
          this.mData.dataForm.doanh_nghiep.nguoi_lien_he.email = null;
        if (valueEmail === "emailDoanhNghiep")
          this.mData.dataForm.doanh_nghiep.email = null;
        if (valueEmail === "emailCaNhan")
          this.mData.dataForm.ca_nhan.email = null;
      }
    },
    fn_approveAgent(formName) {
      this.$refs[formName].validate(async (valid, objectError) => {
        if (valid) {
          this.isPheDuyetDaiLy = true;
        } else {
          let arrKey = Object.keys(objectError);
          if (arrKey.length > 0) {
            this.$refs[arrKey[0]].$el.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
            setTimeout(() => {
              this.$refs[arrKey[0]].focus();
            }, 500);
          }
          this.isPheDuyetDaiLy = false;
          return false;
        }
      });
    },
    fn_updateAgent(formName) {
      this.$refs[formName].validate(async (valid, objectError) => {
        if (valid) {
          this.isCapNhatLaiThongTinDaiLy = true;
        } else {
          let arrKey = Object.keys(objectError);
          if (arrKey.length > 0) {
            this.$refs[arrKey[0]].$el.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
            setTimeout(() => {
              this.$refs[arrKey[0]].focus();
            }, 500);
          }
          this.isCapNhatLaiThongTinDaiLy = false;
          return false;
        }
      });
    },
    async updateInfoAgent() {
      await this.fn_Agent("ruleForm", "update", false);
    },
    async fn_Agent(formName, type, isCapNhatTrangThai) {
      this.$refs[formName].validate(async (valid, objectError) => {
        if (valid) {
          if (this.mData.dataForm.loai == "ca_nhan") {
            delete this.mData.dataForm["doanh_nghiep"];

            this.mData.dataForm.ca_nhan.dien_thoai =
              MethodService.formatPhone84DiDong_CoDinh(
                this.mData.dataForm.ca_nhan.dien_thoai
              );
          } else {
            delete this.mData.dataForm["ca_nhan"];
            this.mData.dataForm.doanh_nghiep.dien_thoai =
              MethodService.formatPhone84DiDong_CoDinh(
                this.mData.dataForm.doanh_nghiep.dien_thoai
              );

            this.mData.dataForm.doanh_nghiep.nguoi_dai_dien.dien_thoai =
              MethodService.formatPhone84DiDong_CoDinh(
                this.mData.dataForm.doanh_nghiep.nguoi_dai_dien.dien_thoai
              );

            this.mData.dataForm.doanh_nghiep.nguoi_lien_he.dien_thoai =
              MethodService.formatPhone84DiDong_CoDinh(
                this.mData.dataForm.doanh_nghiep.nguoi_lien_he.dien_thoai
              );
          }

          if (
            !this.mData.dataForm.thong_tin_thanh_toan &&
            !this.mData.dataForm.thong_tin_thanh_toan.ngan_hang_id &&
            !this.mData.dataForm.thong_tin_thanh_toan.so_tai_khoan &&
            !this.mData.dataForm.thong_tin_thanh_toan.ten_chu_tai_khoan &&
            !this.mData.dataForm.thong_tin_thanh_toan.chi_nhanh
          ) {
            this.mData.dataForm.thong_tin_thanh_toan = undefined
          }

          const tagsArray = [];
          this.tags.forEach((item) => {
            tagsArray.push(item.text);
          });
          this.mData.dataForm.voucher_tags = tagsArray;
          const agt_dai_ly_add = this.mData.dataForm;
          if (
            typeof this.mData.dataForm.thong_tin_thanh_toan == 'object' &&
            !this.mData.dataForm.thong_tin_thanh_toan.ngan_hang_id
          ) {
            delete agt_dai_ly_add["thong_tin_thanh_toan"]
          }
          try {
            if (type == "create") {
              const newId = await mushroom.agt_dai_ly.createAsync(
                agt_dai_ly_add
              );
              if (newId) {
                window.toastr.success("Thêm mới đại lý thành công");
                console.clear()
                this.$router.push({
                  name: "DanhSachDaiLy",
                });
              }
            } else {
              delete agt_dai_ly_add["trang_thai"]; // không cập nhật trạng thái vì đã có nút chuyển trạng thái
              const newId = await mushroom.agt_dai_ly.partialUpdateAsync(
                agt_dai_ly_add
              );
              if (newId) {
                if (!isCapNhatTrangThai) {
                  window.toastr.success("Cập nhật đại lý thành công");
                  await this.fn_initForm();
                  console.clear()
                }
              }
            }
          } catch (e) {
            console.error("Có lỗi: %o", e);
            if (e.code == 409) {
              window.toastr.error("Tên đăng nhập đã tồn tại!");
            } else if (e.meta && e.meta.field === "$unique_key") {
              window.toastr.error("Tên đại lý đã được sử dụng!");
            } else MethodService.showError(e.code);
            return false;
          } finally {
            console.log('zoooo');
            this.isCapNhatLaiThongTinDaiLy = false;
          }
        } else {
          let arrKey = Object.keys(objectError);
          if (arrKey.length > 0) {
            this.$refs[arrKey[0]].$el.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
            setTimeout(() => {
              this.$refs[arrKey[0]].focus();
            }, 500);
          }
          return false;
        }
      });
    },
    async approveAgent() {
      await this.fn_updateStatusAgentAsync("hoat_dong");
    },
    addAgentProvince() {
      this.mData.them_dai_ly_tinh = true;
      this.mData.xem_dai_ly_tinh = false;
      this.mData.cap_nhat_dai_ly_tinh = false;
      this.mData.isAddAgentList = true;
      this.mData.thong_tin_dai_ly_tinh = [];
    },
    detailAgentProvince() {
      this.mData.xem_dai_ly_tinh = true;
      this.mData.them_dai_ly_tinh = false;
      this.mData.cap_nhat_dai_ly_tinh = false;
      this.mData.isAddAgentList = true;
    },
    updateAgentProvince() {
      this.mData.xem_dai_ly_tinh = false;
      this.mData.them_dai_ly_tinh = false;
      this.mData.cap_nhat_dai_ly_tinh = true;
      this.mData.isAddAgentList = true;
    },
    dataAgentProvince(data) {
      this.mData.thong_tin_dai_ly_tinh = data;
    },
    async fn_updateStatusAgent(status) {
      this.$refs["ruleForm"].validate(async (valid) => {
        if (!valid) {
          window.toastr.warning("Vui lòng nhập đầy đủ các thông tin bắt buộc");
          return;
        }
        this.isCapNhatTrangThaiDaiLy = true;
        this.trang_thai_dai_ly_tinh = status;
      });
    },
    async updateStatusAgent() {
      await this.fn_updateStatusAgentAsync(this.trang_thai_dai_ly_tinh);
    },
    async fn_updateStatusAgentAsync(status) {
      const agt_dai_ly_object = {
        id: this.$router.currentRoute.params.id,
        trang_thai: status,
      };
      try {
        const response = await mushroom.agt_dai_ly.partialUpdateAsync(
          agt_dai_ly_object
        );
        if (response.result == this.$router.currentRoute.params.id) {
          window.toastr.success("Cập nhật trạng thái đại lý thành công");
          this.fn_renderStatusAgent(status);
          this.mData.them_dai_ly_tinh = true;
          this.isUpdateStatusActiveAgent = true;
          await this.fn_initForm();
        } else window.toastr.warning("Dữ liệu không thay đổi");
      } catch (e) {
        if (e.code === 409) {
          window.toastr.error("Tài khoản đã tồn tại");
        } else MethodService.showError(e.code);
        this.isUpdateStatusActiveAgent = false;
        this.mData.isAddAgentSuccess = false;
      } finally {
        this.isCapNhatTrangThaiDaiLy = false;
        this.isPheDuyetDaiLy = false;
      }
    },
    async fn_updateHopDongAgent(hopDongId) {
      const agt_dai_ly_object = {
        id: this.$router.currentRoute.params.id,
        hop_dong_file_ids: hopDongId,
      };
      try {
        const newId = await mushroom.agt_dai_ly.partialUpdateAsync(
          agt_dai_ly_object
        );
        if (newId) {
          // chạy lại cập nhật đại lý, đẩy lên trường tai_khoan, sau mới cập nhật trạng thái
          delete this.dataCopy["trang_thai"];
          delete this.dataCopy["id"];
          this.dataCopy["id"] = this.$router.currentRoute.params.id;
          this.dataCopy["tai_khoan"] = this.mData.dataForm.tai_khoan;
          if (this.mData.dataForm.loai == "ca_nhan") {
            delete this.dataCopy["doanh_nghiep"];

            this.dataCopy.ca_nhan.dien_thoai =
              MethodService.formatPhone84DiDong_CoDinh(
                this.dataCopy.ca_nhan.dien_thoai
              );
          } else {
            delete this.dataCopy["ca_nhan"];

            this.dataCopy.doanh_nghiep.dien_thoai =
              MethodService.formatPhone84DiDong_CoDinh(
                this.dataCopy.doanh_nghiep.dien_thoai
              );

            this.dataCopy.doanh_nghiep.nguoi_dai_dien.dien_thoai =
              MethodService.formatPhone84DiDong_CoDinh(
                this.dataCopy.doanh_nghiep.nguoi_dai_dien.dien_thoai
              );

            this.dataCopy.doanh_nghiep.nguoi_lien_he.dien_thoai =
              MethodService.formatPhone84DiDong_CoDinh(
                this.dataCopy.doanh_nghiep.nguoi_lien_he.dien_thoai
              );
          }
          this.dataCopy.hop_dong_file_ids = hopDongId;
          if (this.mData.dataForm.thong_tin_thanh_toan === [{}])
            delete this.dataCopy["thong_tin_thanh_toan"];
          const body = this.dataCopy;
          const res = await mushroom.agt_dai_ly.partialUpdateAsync(body);
          if (res.result) {
            await this.fn_initForm();
            this.mData.reRenderFileViewHopDongFile += 1;
            window.toastr.success("Cập nhật hợp đồng thành công");
          }
        } else {
          this.isUpdateStatusActiveAgent = false;
        }
      } catch (e) {
        window.toastr.error("Cập nhật hợp đồng thất bại");
        return false;
      } finally {
        this.mData.isAddAgentSuccess = false;
      }
    },
    async fn_getIdHopDong(ids) {
      if (ids.length > 0) {
        ids.forEach((item) => {
          this.list_id_hop_dong_file.push(item);
        });
      }
    },
    async fn_updateStatusActiveAgent() {
      await this.fn_updateHopDongAgent(this.list_id_hop_dong_file);
      if (this.isUpdateStatusActiveAgent) {
        setTimeout(() => {
          this.mData.isAddAgentSuccess = false;
          this.mData.isAddAgentList = true;
        }, 1000);
      } else return false;
    },
    fn_backDanhSachDaiLy() {
      this.$router.go(-1);
    },
    reloadListDaiLyTinh() {
      this.reRenderDanhSachDaiLyTinh += 1;
    },
    // gán id tỉnh/thành phố, quận/huyện, phường/xã, địa chỉ cho Văn phòng giao dịch
    setIdProvince(id, index) {
      this.mData.dataForm.doanh_nghiep.van_phong_giao_dich[index].tinh_id = id;
    },
    setIdDistrict(id, index) {
      this.mData.dataForm.doanh_nghiep.van_phong_giao_dich[index].huyen_id = id;
    },
    setIdCommune(id, index) {
      this.mData.dataForm.doanh_nghiep.van_phong_giao_dich[index].xa_id = id;
    },
    setAddress(address, index) {
      this.mData.dataForm.doanh_nghiep.van_phong_giao_dich[index].dia_chi =
        address;
    },

    // gán id tỉnh/thành phố, quận/huyện, phường/xã, địa chỉ cho Thông tin doanh nghiệp
    setIdProvinceDN(id) {
      this.mData.dataForm.doanh_nghiep.dia_chi.tinh_id = id;
    },
    setIdDistrictDN(id) {
      this.mData.dataForm.doanh_nghiep.dia_chi.huyen_id = id;
    },
    setIdCommuneDN(id) {
      this.mData.dataForm.doanh_nghiep.dia_chi.xa_id = id;
    },
    setAddressDN(address) {
      this.mData.dataForm.doanh_nghiep.dia_chi.dia_chi = address;
    },

    // gán id tỉnh/thành phố, quận/huyện, phường/xã, địa chỉ cho Người đại diện doanh nghiệp
    setIdProvinceNDD(id) {
      this.mData.dataForm.doanh_nghiep.nguoi_dai_dien.dia_chi.tinh_id = id;
    },
    setIdDistrictNDD(id) {
      this.mData.dataForm.doanh_nghiep.nguoi_dai_dien.dia_chi.huyen_id = id;
    },
    setIdCommuneNDD(id) {
      this.mData.dataForm.doanh_nghiep.nguoi_dai_dien.dia_chi.xa_id = id;
    },
    setAddressNDD(address) {
      this.mData.dataForm.doanh_nghiep.nguoi_dai_dien.dia_chi.dia_chi = address;
    },

    // gán id tỉnh/thành phố, quận/huyện, phường/xã, địa chỉ cho Người đại diện cá nhân
    setIdProvinceCaNhanNDD(id) {
      this.mData.dataForm.ca_nhan.dia_chi.tinh_id = id;
    },
    setIdDistrictCaNhanNDD(id) {
      this.mData.dataForm.ca_nhan.dia_chi.huyen_id = id;
    },
    setIdCommuneCaNhanNDD(id) {
      this.mData.dataForm.ca_nhan.dia_chi.xa_id = id;
    },
    setAddressCaNhanNDD(address) {
      this.mData.dataForm.ca_nhan.dia_chi.dia_chi = address;
    },

    // gán id tỉnh/thành phố, quận/huyện, phường/xã, địa chỉ cho Người liên hệ
    setIdProvinceNLH(id) {
      this.mData.dataForm.doanh_nghiep.nguoi_lien_he.dia_chi.tinh_id = id;
    },
    setIdDistrictNLH(id) {
      this.mData.dataForm.doanh_nghiep.nguoi_lien_he.dia_chi.huyen_id = id;
    },
    setIdCommuneNLH(id) {
      this.mData.dataForm.doanh_nghiep.nguoi_lien_he.dia_chi.xa_id = id;
    },
    setAddressNLH(address) {
      this.mData.dataForm.doanh_nghiep.nguoi_lien_he.dia_chi.dia_chi = address;
    },
  },
  computed: {
    filteredItems() {
      return this.listVoucherTagsSuggest.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
      });
    },
  },
  async mounted() {
    await this.initDataDefault()
    await this.fn_getAllVoucherTags();
    this.$router.currentRoute.name == "CapNhatDaiLy"
      ? (this.mData.viewMode = "update")
      : this.$router.currentRoute.name == "ChiTietDaiLy"
        ? (this.mData.viewMode = "detail")
        : (this.mData.viewMode = "create");
    if (this.$router.currentRoute.name === "ThemMoiDaiLy") {
      this.mData.validForm.cau_hinh.dang_ky_dong_ho.so_ngay_dung_thu = [];
      this.mData.loading = false;
    } else {
      await this.fn_initForm()
    }
  },
}
